import React, { useState } from 'react';
import SimpleDialog, { SimpleDialogProps } from '../SimpleDialog/SimpleDialog';
import { AppState } from '../../../store/state';
import { AppDispatch } from '../../../store/store';
import { connect } from 'react-redux';
import { InputText } from '../../ui';
import { CategoryEnum, PaperStatusDTO } from '../../../store/paper-status/types.d';
import paperStatusSlice from '../../../store/paper-status/slice';
import { useTranslation } from 'react-i18next';

interface Props extends SimpleDialogProps {
  initialValue: PaperStatusDTO;
  postPaperStatusAction: (data: PaperStatusDTO) => void;
  putPaperStatusAction: (data: PaperStatusDTO) => void;
}

const PaperStatusDialog: React.FC<Props> = ({ initialValue, postPaperStatusAction, putPaperStatusAction, ...rest }) => {
  const { t, i18n } = useTranslation();
  const [data, setData] = useState<PaperStatusDTO>(initialValue);

  let disableButtonCondition = !data.name;

  if (data.category === CategoryEnum.In_Progress) {
    disableButtonCondition = disableButtonCondition || !data.display_name;
  }

  return (
    <SimpleDialog
      {...rest}
      handleOk={() => {
        if (data.id) {
          putPaperStatusAction(data);
        } else {
          postPaperStatusAction(data);
        }
      }}
      disableOkButton={disableButtonCondition}
    >
      <div className="flex flex-col">
        <InputText
          label={t('Name')}
          required
          value={data.name == 'Awaiting decision' ? t('Awaiting decision') : data.name}
          onChange={(e) => setData({ ...data, name: e.target.value })}
          className="mb-5"
          disabled={initialValue.name == 'Awaiting decision' && data.name === 'Awaiting decision'}
        />
        {data.category === CategoryEnum.In_Progress && (
          <InputText
            label={t('Display name for authors')}
            required
            value={data.display_name}
            onChange={(e) => setData({ ...data, display_name: e.target.value })}
            className="mb-5"
          />
        )}
      </div>
    </SimpleDialog>
  );
};

const mapStateToProps = (state: AppState) => ({});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  postPaperStatusAction: (data: PaperStatusDTO) => dispatch(paperStatusSlice.actions['POST:PAPER_STATUS'](data)),
  putPaperStatusAction: (data: PaperStatusDTO) => dispatch(paperStatusSlice.actions['PUT:PAPER_STATUS'](data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PaperStatusDialog);
